    // 新建DOM，将需要打印的内容填充到DOM
    function getPrintContainer(html) {
      // 清除打印
      cleanPrint()
      let container = document.createElement('div')
      container.setAttribute('id', 'print-container')
      container.innerHTML = html
      return container
    }
    // 设置打印样式
    function getStyle() {
      // 新建的dom不需要在页面上展示
      let styleContent = `#print-container {
          display: none;
      }
      @media print {
          body > :not(.print-container) {
          display: none;
      }
      html,
      body {
          display: block !important;
      }
      #print-container {
          display: block;
          width: 900px;
          margin: 0 auto;
          text-align: center !important;
      }
      #print-container .mr10 {
        margin-right: 10px;
      }
  
      #print-container .tac {
        text-align: center;
      }
  
      #print-container .tar {
        text-align: right;
      }
  
      #print-container h2 {
        margin: 0 auto 20px;
        text-align: center;
      }
  
      #print-container table {
        border-collapse: collapse;
        text-align: center;
        margin: 0 auto;
      }
  
      #print-container table span {
        display: inline-block;
      }`
      let style = document.createElement('style')
      style.innerHTML = styleContent
      return style
    }
    // 清空打印的DOM
    function cleanPrint() {
      let divDOM = document.getElementById('print-container')
      // 判断是否存在，有则删除
      if (divDOM) {
        document.querySelector('body').removeChild(divDOM)
      }
    }

    // 等待图片完全加载后再调用打印方法
    function getLoadPromise(dom) {
      let imgs = dom.querySelectorAll('img')
      imgs = [].slice.call(imgs)
      if (imgs.length === 0) {
        return Promise.resolve()
      }
      let finishedCount = 0
      return new Promise(resolve => {
        function check() {
          finishedCount++
          if (finishedCount === imgs.length) {
            resolve()
          }
        }
        imgs.forEach(img => {
          img.addEventListener('load', check)
          img.addEventListener('error', check)
        })
      })
    }
    // 默认暴露打印方法
    export default function printHtml(html) {
      let style = getStyle()
      let container = getPrintContainer(html)
      document.body.appendChild(style)
      document.body.appendChild(container)
      getLoadPromise(container).then(() => {
        // 打印
        window.print()
        document.body.removeChild(style)
        // 如果body中有则删除（这里最好判断一下，避免使用时报错）
        if (document.body.contains(container)) {
          document.body.removeChild(container)
        }
      })
    }